'use client'

import { FormControl, MenuItem, Select } from '@mui/material'
import { useRouter, useSearchParams } from 'next/navigation'

const FacultyCategorySelect = ({ categories = [] }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const currentQ = searchParams.get('q') || 'all'

  const handleChange = (e) => {
    const value = e.target.value
    const params = new URLSearchParams(searchParams.toString())
    if (value === 'all') {
      params.delete('q')
    } else {
      params.set('q', value)
    }
    router.push(`/team/faculty?${params.toString()}`)
  }

  return (
    <FormControl size="small" sx={{ minWidth: 200 }} className="tw:max-sm:w-full">
      <Select
        value={currentQ}
        onChange={handleChange}
        displayEmpty
        sx={{
          borderRadius: '9999px',
          backgroundColor: '#f5f5f5',
          fontSize: '0.875rem',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
            borderWidth: '1px',
          },
        }}
      >
        <MenuItem value="all">All Categories</MenuItem>
        {categories.map((cat) => (
          <MenuItem key={cat.slug} value={cat.slug}>
            {cat.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default FacultyCategorySelect
